<template>
    <FeaturesPageFeaturePanel icon="bw1player"
                              :title="$t('pages.features.playerCard.title')"
                              :desc="$t('pages.features.playerCard.desc')"
                              :checkedOnLoad=true>
        <ul class="playerFeaturesList">
            <li  v-for="(i,index) in $t('pages.features.playerCard.featuresList')" :key="index">{{i}}</li>

        </ul>
        <div class="gallery-container">
            <PlayerScreenshotGallery/>
        </div>
        <h2>
            {{$t('pages.features.playerCard.equipment')}}:
        </h2>
        <div class="recommended-equipment-table">
            <AnimatedCard :title="$t('pages.features.playerCard.equipCards.fullHd.title')"
                          icon="features/recommended-equipment/equipment_1.svg"
                          :desc="$t('pages.features.playerCard.equipCards.fullHd.desc')"
                          link="https://www.intel.com/content/www/us/en/products/boards-kits/nuc/mini-pcs/nuc6cays.html?elq_cid=1211583&erpm_id=1965293">
                {{$t('pages.features.playerCard.equipCards.fullHd.text')}}
            </AnimatedCard>
            <AnimatedCard :title="$t('pages.features.playerCard.equipCards.4k.title')"
                          icon="features/recommended-equipment/equipment_2.svg"
                          :desc="$t('pages.features.playerCard.equipCards.4k.desc')"
                          link="https://www.intel.com/content/www/us/en/products/boards-kits/nuc/mini-pcs/nuc7i3dnktc.html?elq_cid=1211583&erpm_id=1965293">
                {{$t('pages.features.playerCard.equipCards.4k.text')}}
            </AnimatedCard>
            <AnimatedCard :title="$t('pages.features.playerCard.equipCards.16k.title')"
                          icon="features/recommended-equipment/equipment_3.svg"
                          :desc="$t('pages.features.playerCard.equipCards.16k.desc')"
                          link="https://www.dell.com/en-us/work/shop/desktops-all-in-one-pcs/precision-5820-tower-workstation/spd/precision-5820-workstation/xctopt5820us_2?configurationid=923b2236-68c1-4b5a-bb45-45c2c80e41de">
                {{$t('pages.features.playerCard.equipCards.16k.text')}}
            </AnimatedCard>
        </div>
        <p class="requares-difficults">
            {{$t('pages.features.playerCard.minimumHardware')}}
        </p>
        <br/>
        <p class="requares-difficults">
            {{$t('pages.features.playerCard.difficults')}}
        </p>
    </FeaturesPageFeaturePanel>

</template>

<script>
    import FeaturesPageFeaturePanel from "./toolkit/FeaturesPageFeaturePanel";
    import AnimatedCard from "../../../components/AnimatedCard";
    import PlayerScreenshotGallery from "./toolkit/PlayerScreenshotGallery"

    export default {
        name: "PlayerFeature",
        components: {FeaturesPageFeaturePanel, AnimatedCard, PlayerScreenshotGallery}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    h2 {
        font-weight: 300;
    }

    h3 {
        font-weight: 400;
    }

    .gallery-container {
        display: grid;
        justify-items: center;
        padding-right: 1rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    a {
        text-decoration: none;
        color: $primary20;
        font-size: 1rem;
        font-weight: 300;
    }

    a:hover {
        text-decoration: none;
        color: $primary80;
    }

    ul > li {
        font-size: 0.9em;
        margin-bottom: 0.5em;
    }

    .requares-difficults {
        font-weight: 400;
        text-align: justify;
        margin-right: 1em;
    }

    .recommended-equipment-table {
        display: grid;
        grid-template-columns: repeat(auto-fit, 19em);
        column-gap: 2em;
        row-gap: 1rem;
        margin-top: 2em;
        margin-bottom: 2em;
    }

    .hardware-cell {
        display: grid;
        grid-template-columns: auto;
        grid-template-rows: auto auto auto;

    }

    .hardware-cell > label {
        grid-row: 1;
        grid-column: 1;
        font-size: 1.8em;
        justify-self: start;
    }

    .hardware-cell a {
        grid-column: 1;
        grid-row: 1;
        justify-self: end;
    }

    .hardware-cell > img {
        grid-column: 1;
        grid-row-start: 1;
        grid-row-end: 3;
        width: 17em;
        justify-self: end;
        z-index: -1;
    }

    .hardware-cell > p {
        grid-row: 3;
        justify-self: center;
    }
</style>